import React from 'react';
import { Tooltip } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { BrokerJob } from '@warehouse/object-browser/feature-broker';
import { bucketsOf } from '@warehouse/service-log/core';
import { useJobReference } from './use-job-reference';

const NO_BUCKET = '--';

/**
 * Bucket column: the object's bucket, or where the copies of the content live ("N buckets" when spread).
 * Plain text, like the Object Browser's Bucket column.
 */
export function BucketCell({ row }: GridRenderCellParams<BrokerJob, string>) {
	const reference = useJobReference(row);

	switch (reference.kind) {
		case 'object':
			return reference.object ? reference.object.bucketId : NO_BUCKET;
		case 'content': {
			const buckets = bucketsOf(reference.copies);
			if (buckets.length === 0) return NO_BUCKET;
			if (buckets.length === 1) return buckets[0];
			return (
				<Tooltip title={buckets.join(', ')}>
					<span>{`${buckets.length} buckets`}</span>
				</Tooltip>
			);
		}
		default:
			return NO_BUCKET;
	}
}
